module.exports = __webpack_public_path__ + "static/media/020.96026c71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/020.jpg
// module id = 527
// module chunks = 0